import { mapActions, mapGetters } from 'vuex'

import { cloneDeep, get } from 'lodash'

import { Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { RECURRENT_PAYMENTS_FILTER, fillDependence, generateServices, globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.recurrentPayments)

export default function(options = {}) {
  return {
    name: 'RecurrentPaymentsList',

    mixins: [
      generateServices({
        name: Services.recurrentPayments,

        async inputFilter(result) {
          if (result.acceptOffer === undefined) {
            result.acceptOffer = false
          }

          if (!result.Owner) {
            await fillDependence.call(this, result, {
              service: Services.users,
              permissions: permissionPresets.resellerUp,
              pathToId: 'OwnerId',
              pathToObject: 'Owner',
              outputPath: 'Owner',
              picks: PUBLIC_FIELDS_USER
            })
          }

          result.OwnerId = result.OwnerId || result.Owner && result.Owner.id || options.OwnerId

          return result
        },

        outputFilter(result) {
          delete result.acceptOffer

          return result
        },

        find: {
          defaultFilter: cloneDeep(RECURRENT_PAYMENTS_FILTER),
          alwaysCreateFromWebSocket: true,
          alwaysUpdateFromWebSocket: true,
          alwaysRemoveFromWebSocket: true,

          defaultPagination: {
            limit: 10
          }
        },

        get: false,
        update: false,

        remove: {
          manipulateData: false,
          redirect: false
        }
      })
    ],

    data() {
      return {
        showCreateDialog: false,
        showPaymentsDialog: false,
        showUnlockConfirmDialog: false,

        unlockLoading: false,

        RecurrentPaymentId: undefined
      }
    },

    computed: {
      ...mapGetters(
        {
          paymentsMethods: 'payments/methods',
          showCreateRecurrentPaymentDialog: 'payments/showCreateRecurrentPaymentDialog'
        }
      ),

      canGetRecurrentPayments() {
        return this.checkPermissions(`advanced.${Services.recurrentPayments}.get`, permissionPresets.meUp)
      },
      canGetRecurrentPaymentsAsAdmin() {
        return this.checkPermissions(`advanced.${Services.recurrentPayments}.get`)
      },
      canCreateRecurrentPayments() {
        return this.checkPermissions(`advanced.${Services.recurrentPayments}.create`, permissionPresets.meUp)
      }
    },

    watch: {
      showCreateRecurrentPaymentDialog() {
        this.showDialogFromVuex()
      }
    },

    mounted() {
      if (options.isPage) {
        this.rest[Services.recurrentPayments].find()
      } else {
        this.restData[Services.recurrentPayments].find.filter.OwnerId = options.OwnerId || this.account.id
      }
      this.showDialogFromVuex()
      const recurrentPaymentIdFromQuery = get(this.$route, 'query.recurrentPaymentId')
      if (recurrentPaymentIdFromQuery) {
        this.restData[Services.recurrentPayments].find.filter.id = recurrentPaymentIdFromQuery
      }
    },

    methods: {
      ...mapActions({ setShowCreateRecurrentPaymentDialog: 'payments/setShowCreateRecurrentPaymentDialog' }),

      showDialogFromVuex() {
        if (this.showCreateRecurrentPaymentDialog) {
          setTimeout(() => {
            this.showCreateDialog = true
          }, 100)
        }
      },

      async createRecurrentPayment() {
        if (this.restData[Services.recurrentPayments].create.isValid) {
          try {
            const { url } = await this.rest[Services.recurrentPayments].create(this.restData[Services.recurrentPayments].create.data)
            if (url) {
              window.location.href = url
              this.showCreateDialog = false
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      },

      async unlockRecurrentPayment() {
        if (this.canGetRecurrentPaymentsAsAdmin) {
          try {
            this.unlockLoading = true
            await request.get(joinURLPath(pathToAPI, this.RecurrentPaymentId, 'unlock'))
          } catch (error) {
            globalErrorHandler(error)
          } finally {
            this.unlockLoading = false
            this.showUnlockConfirmDialog = false
          }
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
